up.compiler('[hint-dialog]', (element, { htmlContent, onClosePath }) => {
  up.layer.open({
    size: 'auto',
    content: htmlContent,
    onAccepted: onClose,
    onDismissed: onClose,
  })

  function onClose() {
    up.request(onClosePath, { method: 'PATCH' })
  }
})
